import type { IDictionary, ILoader } from '../../appstate';
import { CreateLoaderReducer } from '../../reducers/GeneralReducers';
import type { IProductHeader, ISearchProduct } from '../../values';
import * as RestrictionsActions from './RestrictionsActions';

export interface IAddRestrictionsWorkflowState {
	productNumberDescriptionLookup: IDictionary<IProductHeader>;
	productValidation: ILoader<ISearchProduct>;
	defaultMessage: string;
	allRestrictionsAreValid: boolean;
	isModalEnabled: boolean;
	inProgress: boolean;
	isSuccessfullyAdded: boolean;
	productsCount: {
		total: number;
		isExceeded: boolean;
	};
}

const initialState: IAddRestrictionsWorkflowState = {
	productNumberDescriptionLookup: {},
	productValidation: {
		payload: null,
		inProcess: false,
		error: false,
	},
	allRestrictionsAreValid: false,
	isModalEnabled: false,
	inProgress: false,
	defaultMessage: '',
	isSuccessfullyAdded: false,
	productsCount: {
		total: null,
		isExceeded: false,
	},
};

const productValidationReducer = CreateLoaderReducer<ISearchProduct>({
	startAction: RestrictionsActions.SEARCH_PRODUCT_NUMBER_SUPPLIER_ID,
});

export function addRestrictionByProductNumberReducer(
	state = initialState,
	action
): IAddRestrictionsWorkflowState {
	switch (action.type) {
		case RestrictionsActions.SEARCH_PRODUCT_NUMBER_SUPPLIER_ID:
		case RestrictionsActions.SEARCH_PRODUCT_NUMBER_SUPPLIER_ID_ERROR:
			return {
				...state,
				productValidation: productValidationReducer(
					state.productValidation,
					action
				),
			};
		case RestrictionsActions.SEARCH_PRODUCT_NUMBER_SUPPLIER_ID_SUCCESS: {
			let newLookup = state.productNumberDescriptionLookup;

			if (action.payload) {
				newLookup = {
					...state.productNumberDescriptionLookup,
				};

				for (const productNumber in action.payload) {
					if (
						!Object.prototype.hasOwnProperty.call(action.payload, productNumber)
					) {
						continue;
					}
					newLookup[productNumber] = action.payload[productNumber];
				}
			}
			return {
				...state,
				productNumberDescriptionLookup: newLookup,
				productValidation: productValidationReducer(
					state.productValidation,
					action
				),
			};
		}
		case RestrictionsActions.MAXIMUM_RESTRICTIONS_EXCEEDED:
			return {
				...state,
				productsCount: {
					total: action.payload.productNumbers,
					isExceeded: action.payload.isExceeded,
				},
			};
		case RestrictionsActions.RESET_PRODUCT_VALIDATION_AND_LOOKUP:
			return {
				...state,
				productNumberDescriptionLookup:
					initialState.productNumberDescriptionLookup,
				productValidation: initialState.productValidation,
			};
		case RestrictionsActions.UPDATE_DEFAULT_RESTRICTION_MESSAGE:
			return {
				...state,
				defaultMessage: action.payload.newMessage.substring(0, 200),
			};
		case RestrictionsActions.ENABLE_RESTRICT_BUTTON:
			return {
				...state,
				allRestrictionsAreValid: action.payload.isEnabled,
			};
		case RestrictionsActions.RESTRICT_PRODUCTS:
			return {
				...state,
				inProgress: action.payload,
			};
		case RestrictionsActions.RESTRICT_PRODUCTS_ERROR:
			return {
				...state,
				inProgress: false,
				isModalEnabled: false,
			};
		case RestrictionsActions.RESTRICT_PRODUCTS_SUCCESS:
			return {
				...state,
				productNumberDescriptionLookup: {},
				productValidation: {
					payload: null,
					inProcess: false,
					error: false,
				},
				isModalEnabled: false,
				inProgress: false,
				isSuccessfullyAdded: true,
			};
		case RestrictionsActions.SHOW_REMOVE_MODAL:
			return {
				...state,
				isModalEnabled: true,
			};
		case RestrictionsActions.CLOSE_REMOVE_MODAL:
			return {
				...state,
				productNumberDescriptionLookup: {},
				productValidation: {
					payload: null,
					inProcess: false,
					error: false,
				},
				isModalEnabled: false,
				inProgress: false,
			};
		case RestrictionsActions.RESET_ISSUCCESSFULLYADDED:
			return {
				...state,
				isSuccessfullyAdded: false,
			};
	}
	return state;
}
